import { default as _91_46_46_46slug_93VHtADaQLChMeta } from "D:/a/1/s/frontend/web/src/pages/[...slug].vue?macro=true";
import { default as _404vf3HyVsyA9Meta } from "D:/a/1/s/frontend/web/src/pages/404.vue?macro=true";
import { default as indexliC8sSBnMzMeta } from "D:/a/1/s/frontend/web/src/pages/a-solution-for-your-organisation/index.vue?macro=true";
import { default as _91tab_939LR8gsEyUcMeta } from "D:/a/1/s/frontend/web/src/pages/account/[tab].vue?macro=true";
import { default as indexhk33FIzKl1Meta } from "D:/a/1/s/frontend/web/src/pages/account/index.vue?macro=true";
import { default as _91form_930UyILvlQzaMeta } from "D:/a/1/s/frontend/web/src/pages/apply/[form].vue?macro=true";
import { default as completeigkl96QgJuMeta } from "D:/a/1/s/frontend/web/src/pages/apply/complete.vue?macro=true";
import { default as indexlsFpnfqTOtMeta } from "D:/a/1/s/frontend/web/src/pages/azure/index.vue?macro=true";
import { default as indexCFCi0uUZQaMeta } from "D:/a/1/s/frontend/web/src/pages/coaching-listing/index.vue?macro=true";
import { default as indexlyts29YF35Meta } from "D:/a/1/s/frontend/web/src/pages/content/index.vue?macro=true";
import { default as indexS8q2G3ZjQrMeta } from "D:/a/1/s/frontend/web/src/pages/course-finder/index.vue?macro=true";
import { default as indexYNM0FjsgEeMeta } from "D:/a/1/s/frontend/web/src/pages/course-finder/results/index.vue?macro=true";
import { default as _91tab_93eWtPsjGFDvMeta } from "D:/a/1/s/frontend/web/src/pages/course-listing/[tab].vue?macro=true";
import { default as _91tab_93UdRI0I3ME5Meta } from "D:/a/1/s/frontend/web/src/pages/faculty/[tab].vue?macro=true";
import { default as indexksSHhMezozMeta } from "D:/a/1/s/frontend/web/src/pages/faculty/index.vue?macro=true";
import { default as indexrrLHSU6FUXMeta } from "D:/a/1/s/frontend/web/src/pages/human-acumen-booklet/index.vue?macro=true";
import { default as indexFDng2lYIK9Meta } from "D:/a/1/s/frontend/web/src/pages/index.vue?macro=true";
import { default as indexSjkorqX9TJMeta } from "D:/a/1/s/frontend/web/src/pages/info-central/index.vue?macro=true";
import { default as indexHD0AKLCAggMeta } from "D:/a/1/s/frontend/web/src/pages/legal/index.vue?macro=true";
import { default as indexMJrUCsdYkCMeta } from "D:/a/1/s/frontend/web/src/pages/news/index.vue?macro=true";
import { default as confirmation9UyYnO9WoRMeta } from "D:/a/1/s/frontend/web/src/pages/payment/confirmation.vue?macro=true";
import { default as indexf05w3MWZ2oMeta } from "D:/a/1/s/frontend/web/src/pages/payment/index.vue?macro=true";
import { default as indexv6DDLsP4quMeta } from "D:/a/1/s/frontend/web/src/pages/preview/index.vue?macro=true";
import { default as indexTb5LQiXJ09Meta } from "D:/a/1/s/frontend/web/src/pages/preview/programmes/[tab]/index.vue?macro=true";
import { default as _91tab_93ES4rxDS3zUMeta } from "D:/a/1/s/frontend/web/src/pages/profile/[tab].vue?macro=true";
import { default as index9BaNDNk0cUMeta } from "D:/a/1/s/frontend/web/src/pages/profile/index.vue?macro=true";
import { default as indexukFzJIaVhPMeta } from "D:/a/1/s/frontend/web/src/pages/programmes/[tab]/index.vue?macro=true";
import { default as reset_45passwordwTWwAhQSozMeta } from "D:/a/1/s/frontend/web/src/pages/reset-password.vue?macro=true";
import { default as font_45testbLrNq91XtQMeta } from "D:/a/1/s/frontend/web/src/pages/sample/font-test.vue?macro=true";
import { default as indextxv7NxpB82Meta } from "D:/a/1/s/frontend/web/src/pages/sample/index.vue?macro=true";
import { default as notificationYx36PgKZGCMeta } from "D:/a/1/s/frontend/web/src/pages/sample/notification.vue?macro=true";
import { default as programmesTestzlRvuwrgltMeta } from "D:/a/1/s/frontend/web/src/pages/sample/programmesTest.vue?macro=true";
import { default as indexHmj1EJ5IYKMeta } from "D:/a/1/s/frontend/web/src/pages/search/index.vue?macro=true";
import { default as indexzrXfKE9iqCMeta } from "D:/a/1/s/frontend/web/src/pages/settings/index.vue?macro=true";
import { default as indexzC0hss4EoJMeta } from "D:/a/1/s/frontend/web/src/pages/sitemap/index.vue?macro=true";
import { default as user_45verificationGwVd87owB7Meta } from "D:/a/1/s/frontend/web/src/pages/user-verification.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93VHtADaQLChMeta?.name ?? "slug",
    path: _91_46_46_46slug_93VHtADaQLChMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93VHtADaQLChMeta || {},
    alias: _91_46_46_46slug_93VHtADaQLChMeta?.alias || [],
    redirect: _91_46_46_46slug_93VHtADaQLChMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _404vf3HyVsyA9Meta?.name ?? "404",
    path: _404vf3HyVsyA9Meta?.path ?? "/404",
    meta: _404vf3HyVsyA9Meta || {},
    alias: _404vf3HyVsyA9Meta?.alias || [],
    redirect: _404vf3HyVsyA9Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: indexliC8sSBnMzMeta?.name ?? "a-solution-for-your-organisation",
    path: indexliC8sSBnMzMeta?.path ?? "/a-solution-for-your-organisation",
    meta: indexliC8sSBnMzMeta || {},
    alias: indexliC8sSBnMzMeta?.alias || [],
    redirect: indexliC8sSBnMzMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/a-solution-for-your-organisation/index.vue").then(m => m.default || m)
  },
  {
    name: _91tab_939LR8gsEyUcMeta?.name ?? "account-tab",
    path: _91tab_939LR8gsEyUcMeta?.path ?? "/account/:tab()",
    meta: _91tab_939LR8gsEyUcMeta || {},
    alias: _91tab_939LR8gsEyUcMeta?.alias || [],
    redirect: _91tab_939LR8gsEyUcMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/account/[tab].vue").then(m => m.default || m)
  },
  {
    name: indexhk33FIzKl1Meta?.name ?? "account",
    path: indexhk33FIzKl1Meta?.path ?? "/account",
    meta: indexhk33FIzKl1Meta || {},
    alias: indexhk33FIzKl1Meta?.alias || [],
    redirect: indexhk33FIzKl1Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: _91form_930UyILvlQzaMeta?.name ?? "apply-form",
    path: _91form_930UyILvlQzaMeta?.path ?? "/apply/:form()",
    meta: _91form_930UyILvlQzaMeta || {},
    alias: _91form_930UyILvlQzaMeta?.alias || [],
    redirect: _91form_930UyILvlQzaMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/apply/[form].vue").then(m => m.default || m)
  },
  {
    name: completeigkl96QgJuMeta?.name ?? "apply-complete",
    path: completeigkl96QgJuMeta?.path ?? "/apply/complete",
    meta: completeigkl96QgJuMeta || {},
    alias: completeigkl96QgJuMeta?.alias || [],
    redirect: completeigkl96QgJuMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/apply/complete.vue").then(m => m.default || m)
  },
  {
    name: indexlsFpnfqTOtMeta?.name ?? "azure",
    path: indexlsFpnfqTOtMeta?.path ?? "/azure",
    meta: indexlsFpnfqTOtMeta || {},
    alias: indexlsFpnfqTOtMeta?.alias || [],
    redirect: indexlsFpnfqTOtMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/azure/index.vue").then(m => m.default || m)
  },
  {
    name: indexCFCi0uUZQaMeta?.name ?? "coaching-listing",
    path: indexCFCi0uUZQaMeta?.path ?? "/coaching-listing",
    meta: indexCFCi0uUZQaMeta || {},
    alias: indexCFCi0uUZQaMeta?.alias || [],
    redirect: indexCFCi0uUZQaMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/coaching-listing/index.vue").then(m => m.default || m)
  },
  {
    name: indexlyts29YF35Meta?.name ?? "content",
    path: indexlyts29YF35Meta?.path ?? "/content",
    meta: indexlyts29YF35Meta || {},
    alias: indexlyts29YF35Meta?.alias || [],
    redirect: indexlyts29YF35Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/content/index.vue").then(m => m.default || m)
  },
  {
    name: indexS8q2G3ZjQrMeta?.name ?? "course-finder",
    path: indexS8q2G3ZjQrMeta?.path ?? "/course-finder",
    meta: indexS8q2G3ZjQrMeta || {},
    alias: indexS8q2G3ZjQrMeta?.alias || [],
    redirect: indexS8q2G3ZjQrMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/course-finder/index.vue").then(m => m.default || m)
  },
  {
    name: indexYNM0FjsgEeMeta?.name ?? "course-finder-results",
    path: indexYNM0FjsgEeMeta?.path ?? "/course-finder/results",
    meta: indexYNM0FjsgEeMeta || {},
    alias: indexYNM0FjsgEeMeta?.alias || [],
    redirect: indexYNM0FjsgEeMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/course-finder/results/index.vue").then(m => m.default || m)
  },
  {
    name: _91tab_93eWtPsjGFDvMeta?.name ?? "course-listing-tab",
    path: _91tab_93eWtPsjGFDvMeta?.path ?? "/course-listing/:tab()",
    meta: _91tab_93eWtPsjGFDvMeta || {},
    alias: _91tab_93eWtPsjGFDvMeta?.alias || [],
    redirect: _91tab_93eWtPsjGFDvMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/course-listing/[tab].vue").then(m => m.default || m)
  },
  {
    name: _91tab_93UdRI0I3ME5Meta?.name ?? "faculty-tab",
    path: _91tab_93UdRI0I3ME5Meta?.path ?? "/faculty/:tab()",
    meta: _91tab_93UdRI0I3ME5Meta || {},
    alias: _91tab_93UdRI0I3ME5Meta?.alias || [],
    redirect: _91tab_93UdRI0I3ME5Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/faculty/[tab].vue").then(m => m.default || m)
  },
  {
    name: indexksSHhMezozMeta?.name ?? "faculty",
    path: indexksSHhMezozMeta?.path ?? "/faculty",
    meta: indexksSHhMezozMeta || {},
    alias: indexksSHhMezozMeta?.alias || [],
    redirect: indexksSHhMezozMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/faculty/index.vue").then(m => m.default || m)
  },
  {
    name: indexrrLHSU6FUXMeta?.name ?? "human-acumen-booklet",
    path: indexrrLHSU6FUXMeta?.path ?? "/human-acumen-booklet",
    meta: indexrrLHSU6FUXMeta || {},
    alias: indexrrLHSU6FUXMeta?.alias || [],
    redirect: indexrrLHSU6FUXMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/human-acumen-booklet/index.vue").then(m => m.default || m)
  },
  {
    name: indexFDng2lYIK9Meta?.name ?? "index",
    path: indexFDng2lYIK9Meta?.path ?? "/",
    meta: indexFDng2lYIK9Meta || {},
    alias: indexFDng2lYIK9Meta?.alias || [],
    redirect: indexFDng2lYIK9Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexSjkorqX9TJMeta?.name ?? "info-central",
    path: indexSjkorqX9TJMeta?.path ?? "/info-central",
    meta: indexSjkorqX9TJMeta || {},
    alias: indexSjkorqX9TJMeta?.alias || [],
    redirect: indexSjkorqX9TJMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/info-central/index.vue").then(m => m.default || m)
  },
  {
    name: indexHD0AKLCAggMeta?.name ?? "legal",
    path: indexHD0AKLCAggMeta?.path ?? "/legal",
    meta: indexHD0AKLCAggMeta || {},
    alias: indexHD0AKLCAggMeta?.alias || [],
    redirect: indexHD0AKLCAggMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/legal/index.vue").then(m => m.default || m)
  },
  {
    name: indexMJrUCsdYkCMeta?.name ?? "news",
    path: indexMJrUCsdYkCMeta?.path ?? "/news",
    meta: indexMJrUCsdYkCMeta || {},
    alias: indexMJrUCsdYkCMeta?.alias || [],
    redirect: indexMJrUCsdYkCMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: confirmation9UyYnO9WoRMeta?.name ?? "payment-confirmation",
    path: confirmation9UyYnO9WoRMeta?.path ?? "/payment/confirmation",
    meta: confirmation9UyYnO9WoRMeta || {},
    alias: confirmation9UyYnO9WoRMeta?.alias || [],
    redirect: confirmation9UyYnO9WoRMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/payment/confirmation.vue").then(m => m.default || m)
  },
  {
    name: indexf05w3MWZ2oMeta?.name ?? "payment",
    path: indexf05w3MWZ2oMeta?.path ?? "/payment",
    meta: indexf05w3MWZ2oMeta || {},
    alias: indexf05w3MWZ2oMeta?.alias || [],
    redirect: indexf05w3MWZ2oMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/payment/index.vue").then(m => m.default || m)
  },
  {
    name: indexv6DDLsP4quMeta?.name ?? "preview",
    path: indexv6DDLsP4quMeta?.path ?? "/preview",
    meta: indexv6DDLsP4quMeta || {},
    alias: indexv6DDLsP4quMeta?.alias || [],
    redirect: indexv6DDLsP4quMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/preview/index.vue").then(m => m.default || m)
  },
  {
    name: indexTb5LQiXJ09Meta?.name ?? "preview-programmes-tab",
    path: indexTb5LQiXJ09Meta?.path ?? "/preview/programmes/:tab()",
    meta: indexTb5LQiXJ09Meta || {},
    alias: indexTb5LQiXJ09Meta?.alias || [],
    redirect: indexTb5LQiXJ09Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/preview/programmes/[tab]/index.vue").then(m => m.default || m)
  },
  {
    name: _91tab_93ES4rxDS3zUMeta?.name ?? "profile-tab",
    path: _91tab_93ES4rxDS3zUMeta?.path ?? "/profile/:tab()",
    meta: _91tab_93ES4rxDS3zUMeta || {},
    alias: _91tab_93ES4rxDS3zUMeta?.alias || [],
    redirect: _91tab_93ES4rxDS3zUMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/profile/[tab].vue").then(m => m.default || m)
  },
  {
    name: index9BaNDNk0cUMeta?.name ?? "profile",
    path: index9BaNDNk0cUMeta?.path ?? "/profile",
    meta: index9BaNDNk0cUMeta || {},
    alias: index9BaNDNk0cUMeta?.alias || [],
    redirect: index9BaNDNk0cUMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexukFzJIaVhPMeta?.name ?? "programmes-tab",
    path: indexukFzJIaVhPMeta?.path ?? "/programmes/:tab()",
    meta: indexukFzJIaVhPMeta || {},
    alias: indexukFzJIaVhPMeta?.alias || [],
    redirect: indexukFzJIaVhPMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/programmes/[tab]/index.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordwTWwAhQSozMeta?.name ?? "reset-password",
    path: reset_45passwordwTWwAhQSozMeta?.path ?? "/reset-password",
    meta: reset_45passwordwTWwAhQSozMeta || {},
    alias: reset_45passwordwTWwAhQSozMeta?.alias || [],
    redirect: reset_45passwordwTWwAhQSozMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: font_45testbLrNq91XtQMeta?.name ?? "sample-font-test",
    path: font_45testbLrNq91XtQMeta?.path ?? "/sample/font-test",
    meta: font_45testbLrNq91XtQMeta || {},
    alias: font_45testbLrNq91XtQMeta?.alias || [],
    redirect: font_45testbLrNq91XtQMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/sample/font-test.vue").then(m => m.default || m)
  },
  {
    name: indextxv7NxpB82Meta?.name ?? "sample",
    path: indextxv7NxpB82Meta?.path ?? "/sample",
    meta: indextxv7NxpB82Meta || {},
    alias: indextxv7NxpB82Meta?.alias || [],
    redirect: indextxv7NxpB82Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/sample/index.vue").then(m => m.default || m)
  },
  {
    name: notificationYx36PgKZGCMeta?.name ?? "sample-notification",
    path: notificationYx36PgKZGCMeta?.path ?? "/sample/notification",
    meta: notificationYx36PgKZGCMeta || {},
    alias: notificationYx36PgKZGCMeta?.alias || [],
    redirect: notificationYx36PgKZGCMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/sample/notification.vue").then(m => m.default || m)
  },
  {
    name: programmesTestzlRvuwrgltMeta?.name ?? "sample-programmesTest",
    path: programmesTestzlRvuwrgltMeta?.path ?? "/sample/programmesTest",
    meta: programmesTestzlRvuwrgltMeta || {},
    alias: programmesTestzlRvuwrgltMeta?.alias || [],
    redirect: programmesTestzlRvuwrgltMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/sample/programmesTest.vue").then(m => m.default || m)
  },
  {
    name: indexHmj1EJ5IYKMeta?.name ?? "search",
    path: indexHmj1EJ5IYKMeta?.path ?? "/search",
    meta: indexHmj1EJ5IYKMeta || {},
    alias: indexHmj1EJ5IYKMeta?.alias || [],
    redirect: indexHmj1EJ5IYKMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexzrXfKE9iqCMeta?.name ?? "settings",
    path: indexzrXfKE9iqCMeta?.path ?? "/settings",
    meta: indexzrXfKE9iqCMeta || {},
    alias: indexzrXfKE9iqCMeta?.alias || [],
    redirect: indexzrXfKE9iqCMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexzC0hss4EoJMeta?.name ?? "sitemap",
    path: indexzC0hss4EoJMeta?.path ?? "/sitemap",
    meta: indexzC0hss4EoJMeta || {},
    alias: indexzC0hss4EoJMeta?.alias || [],
    redirect: indexzC0hss4EoJMeta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/sitemap/index.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationGwVd87owB7Meta?.name ?? "user-verification",
    path: user_45verificationGwVd87owB7Meta?.path ?? "/user-verification",
    meta: user_45verificationGwVd87owB7Meta || {},
    alias: user_45verificationGwVd87owB7Meta?.alias || [],
    redirect: user_45verificationGwVd87owB7Meta?.redirect,
    component: () => import("D:/a/1/s/frontend/web/src/pages/user-verification.vue").then(m => m.default || m)
  }
]